import determineTarget from './determine-target';
import toggleElement from './toggle-element';
import setupFocusTrap from './focus-trap';

export default function setupTabs() {
	document.querySelectorAll( '.js-tab-set' ).forEach( tabSet => {
		const tabs = tabSet.querySelectorAll( '.js-tab' );
		const panels = tabSet.querySelectorAll( '.js-tab-panel' );
		const timer = parseInt( tabSet.dataset.timer ?? 0 );
		let auto;
		let current = 0;

		// Mark all panels as hidden to start
		panels.forEach( panel => {
			panel.setAttribute( 'aria-hidden', true );
		} );

		function switchToTab( tab, focus ) {
			current = [ ...tabs ].indexOf( tab );
			const panel = determineTarget( tab );

			toggleElement( panel, true, focus );

			panels.forEach( _panel => {
				if ( _panel.getAttribute( 'aria-hidden' ) === 'false' && _panel !== panel ) {
					toggleElement( _panel, false );
				}
			} );
		}

		tabs.forEach( tab => {
			tab.addEventListener( 'click', event => {
				event.preventDefault();
				clearTimeout( auto );
				tabSet.classList.remove( 'has-timer' );
				switchToTab( tab, 'focus' );
			} );
		} );

		setupFocusTrap( tabSet, tabs, {
			arrowKeys: true,
			assumeFocusable: true,
		}, switchToTab );

		switchToTab( tabs[ 0 ] );

		if ( timer ) {
			tabSet.classList.add( 'has-timer' );
			tabSet.style.setProperty( '--auto-delay', `${ timer }ms` );

			function autoAdvance() {
				current++;
				if ( current >= tabs.length ) {
					current = 0;
				}

				switchToTab( tabs[ current ] );
				auto = setTimeout( autoAdvance, timer );
			}

			auto = setTimeout( autoAdvance, timer );
		}
	} );
}
